import React, { memo } from 'react';
import s from './index.module.scss';
import locales from '../../../../../../../../content.json';

const Delimiter = memo(function Delimiter() {
  return (
    <div className={s.delimiter}>
      <div className={s.delimiter__line} />
      <span className={s.delimiter__text}>{locales[window.userLang].or}</span>
      <div className={s.delimiter__line} />
    </div>
  );
});

export default Delimiter;
